export default __webpack_public_path__ + "static/media/generalViewSingleWithoutSecondaryDrain.73f564fd.png";